import React, { useRef, useEffect } from "react";

function BackCard({ display, color }) {
  const titlecolorBack = useRef();

  useEffect(() => {
    titlecolorBack.current.style.color = color;
  }, [color]);

  return (
    <div className={`card ${display.backgroundDiv} ${display.text}`}>
      <div className="head-card">
        <span className="darkdivColor"></span>
      </div>
      <div className="body-card">
        <div className="title-wrap">
          <h2 className="textTitle" ref={titlecolorBack}>
            All Links
          </h2>
        </div>
        <ul className={`box-card-link textSmall textMedium ${display.text}`}>
          <li>My Link 1</li>
          <li>My Link 2</li>
          <li>My Link 3</li>
          <li>My Link 4</li>
        </ul>
      </div>
      <div className={`footer-card ${display.backgroundDiv}`}>
        <p className={`textSmall`}>
          from <b>flipcard</b>
        </p>
      </div>
    </div>
  );
}

export default BackCard;
